import { get } from "@ember/object"
import Patch from "@shared/models/patch-updater"
import _ from "lodash"
import defaultLessonActivity from "./default-lesson-activity"
import defaultLessonContext from "./default-lesson-context"
import defaultLessonModels from "./default-lesson-models"

export const LESSON_STANDARDS_TOGGLE_PUBLIC = {
  name: "LESSON_STANDARDS_TOGGLE_PUBLIC",

  params: {
    cardStackId: "string",
    cardId: "string",
    value: "boolean",
    calledFrom: "string",
  },

  // are we not going to make this an undoable action? we don't send over an originalValue so I'm assuming not right now.
  patches(payload) {
    let patch = Patch.create("card-stack", payload.cardStackId, "attributes.cards", {
      id: payload.cardId,
    }).set("embedded", "attributes.isPublic", payload.value).patch

    return [patch]
  },

  // TODO ADd undo patches

  narrative(payload, findFn, userId) {
    let models = defaultLessonModels(payload, findFn, userId)
    let context = defaultLessonContext(payload, models)
    let newContext = _.assign({}, context, {
      isPublic: payload.value,
      calledFrom: payload.calledFrom,
    })

    let count = get(payload, "standards.length")
    let noun = count === 1 ? "standard" : "standards"
    let description = `Pasted ${count} ${noun}`

    return {
      title: "Lesson Standards Pasted",
      titleForAnalytics: "Standards - toggle public",
      description: description,
      context: newContext,
      activity: defaultLessonActivity(payload, models),
    }
  },
}
